import Link from 'next/link';

interface IBannerProps {
  color: string;
  title: string;
}

export const Banner: React.FC<IBannerProps> = ({ title, color }) => {
  return (
    <>
      <Link href="/collections/noel" legacyBehavior>
        <a data-testid="Banner-go-to-collections-noel" className="tw-w-full">
          <div className="container">
            <p>{title}</p>
          </div>
        </a>
      </Link>
      <style jsx>{`
        .container {
          background-color: ${color};
          height: 100%;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 32px;
          border-radius: 4px;
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
        }

        .container > p {
          color: var(--white);
          font-weight: var(--font-weight-bold);
          padding: 12px 15%;
        }
      `}</style>
    </>
  );
};
